import { Mail, Phone, MapPin, ShieldCheck } from "lucide-react";
import EnquiryForm from "./EnquiryForm";
import Reveal, { Eyebrow } from "./Reveal";
import { useSite, phoneDisplay } from "../context/SiteContext";

export default function ContactSection({ defaultType = "" }) {
  const site = useSite();
  return (
    <section id="contact" data-testid="contact-section" className="py-16 md:py-24 lg:py-28 bg-paper scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-5">
            <Reveal>
              <Eyebrow>Start Your Project</Eyebrow>
              <h2 className="mt-4 font-display font-bold text-3xl md:text-4xl tracking-tight text-ink leading-[1.05] display-expanded">
                Have a Project in Mind?
              </h2>
              <p className="mt-5 text-slate2 leading-relaxed">
                Big or small, tell us what you're planning and we'll be happy to have a chat — renovations, extensions, new builds, bathrooms, decks, repairs or anything in between.
              </p>
              <p className="mt-4 text-slate2 leading-relaxed">
                Already have plans, drawings or specifications? Upload them with the form and send everything directly to Razor Build. No plans yet? No problem — just tell us what you're thinking.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-8 bg-ink text-white p-7 md:p-8">
                <p className="font-display font-bold text-xl">Razor Build Limited</p>
                <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-gold mt-1.5">Build • Renovate • Maintain</p>
                <div className="mt-6 space-y-4 text-sm">
                  <a href={`mailto:${site.email}`} data-testid="contact-email-link" className="flex items-center gap-3 text-white/80 hover:text-gold transition-colors">
                    <Mail className="w-4 h-4 text-gold shrink-0" /> {site.email}
                  </a>
                  <a href={`tel:${site.phone}`} data-testid="contact-phone-link" className="flex items-center gap-3 text-white/80 hover:text-gold transition-colors">
                    <Phone className="w-4 h-4 text-gold shrink-0" /> {phoneDisplay(site.phone)}
                  </a>
                  <p className="flex items-center gap-3 text-white/80">
                    <MapPin className="w-4 h-4 text-gold shrink-0" /> Wellington Region
                  </p>
                </div>
                <div className="mt-7 pt-5 border-t border-white/10 flex items-center gap-3 text-xs text-white/50">
                  <ShieldCheck className="w-4 h-4 text-gold shrink-0" />
                  Licensed Building Practitioner · Fully Insured · 10+ Years Experience
                </div>
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.15}>
              <EnquiryForm defaultType={defaultType} />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
